<div class="modal-header">
  <h4 class="modal-title">Confirm</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Are you sure you want to remove the selected item?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close(false)">No, Cancel</button>
  <button type="button" class="btn btn-danger" (click)="activeModal.close(true)">Yes, Remove it</button>
</div>
